import { render, staticRenderFns } from "./SelecaoMedicoLista.vue?vue&type=template&id=9f17e830&"
import script from "./SelecaoMedicoLista.vue?vue&type=script&lang=js&"
export * from "./SelecaoMedicoLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports